import { Organization } from '@shared/models';
import { SimpleComparator } from '@shared/helpers';
import { SortDirection } from '@gea/digital-ui-lib';

export enum SORT_COLUMN {
  ID = 'id',
  NAME = 'name',
  FAULTS = 'faults',
  MACHINE_NAME = 'machineName',
  FAULT_NAME = 'faultName',
  COUNT_WARNINGS = 'countWarnings',
  COUNT_SHUTDOWNS = 'countShutdowns',
  COUNT_PENDING = 'countPending',
  TOTAL_PENDING = 'totalPending',
  COUNT_SOLVED = 'countSolved',
}

export class OrganizationsComparator {
  static by(columnName: SORT_COLUMN, sortingOrder: SortDirection) {
    if (columnName !== SORT_COLUMN.FAULTS) {
      return SimpleComparator.by<Organization>(columnName, sortingOrder);
    } else {
      return OrganizationsComparator.byFault(sortingOrder);
    }
  }

  static byFault(sortOrder: SortDirection) {
    const order = sortOrder === SortDirection.ASCENDING ? 1 : -1;
    const reverseOrder = order * -1;

    //SortingOrder by pending shutdowns then by pending warnings then by name
    return (a: Organization, b: Organization) => {
      if (a.countShutdowns > b.countShutdowns) {
        return order;
      } else if (a.countShutdowns < b.countShutdowns) {
        return reverseOrder;
      } else {
        // pending shutdowns are the same
        if (a.countWarnings > b.countWarnings) {
          return order;
        } else if (a.countWarnings < b.countWarnings) {
          return reverseOrder;
        } else {
          // pending shutdowns and warnings are the same
          return SimpleComparator.by<Organization>(SORT_COLUMN.NAME, sortOrder)(a, b);
        }
      }
    };
  }
}
